import React, { useState } from 'react';
import { Tabs, Card, Row, Col, Progress, Button } from 'antd';
import './userProfileAttendanceDetailsV3.css'
import UserAttendanceTabV3 from './userAttendanceTabV3';
import PageDataLoader from 'components/pageDataLoader';
import UserGeofenceTabV3 from './userGeofenceTabV3';
import ProfileLeaves from './profileLeaves';

const { TabPane } = Tabs;

const UserProfileAttendanceDetailsV3 = ({ isScrolled , specificUserProfile, setIsScrolled}) => {
    const [pageLoader, setPageLoader] = useState(false);
    const [selectTab, setSelectTab] = useState('')
    const handleTabChange = (key) => {
        if (key == '2' || key =='3' || key == '1') {
          setIsScrolled(true);
        } else {
          setIsScrolled(false);
        }
      };

      console.log("specificUserProfile",specificUserProfile);
    return (
        <div style={{height:'100%', width:'100%'}}>
            <Tabs defaultActiveKey="1" className="custom-tabs" onTabClick={handleTabChange}>
                <TabPane tab="Attendance" key="1">
                  <UserAttendanceTabV3 isScrolled={isScrolled} specificUserProfile={specificUserProfile} setPageLoader={setPageLoader}/>
                </TabPane>
                <TabPane tab="Leaves" key="2" >
                   <ProfileLeaves specificUserProfile={specificUserProfile}/>
                </TabPane>
                <TabPane tab="Geofence & Holidays" key="3">
                  <UserGeofenceTabV3 isScrolled={isScrolled} specificUserProfile={specificUserProfile} setPageLoader={setPageLoader}/>
                </TabPane>
            </Tabs>

            <PageDataLoader visible={pageLoader} />

        </div>

    );
};

export default UserProfileAttendanceDetailsV3;
